/**
 * @module services/whatsappNotificationsConfig
 * @description Servicio para el ABM admin de NOTIFICACIONES por WhatsApp
 *              (recetas, órdenes médicas, confirmación de turnos).
 *              Independiente del servicio `whatsappConfig` que cubre
 *              MONITOREO de pacientes (tasks vital/checkin/medication +
 *              LLM parser).
 *
 *              Endpoints expuestos por
 *              `components/whatsapp-notifications-config/route.js` en la API.
 *              Responses tienen `apiKey` mascarado (`hasApiKey: true/false`).
 */
import api from "./api";

const whatsappNotificationsConfigService = {
  /**
   * @description Obtiene la config de notificaciones de la org. Si no
   *              existe, devuelve un shape vacío con defaults para que
   *              el form pueda renderizar.
   * @returns {Promise<Object>} { credentials, types }
   */
  getConfig() {
    return api.get("/whatsapp-notifications-config");
  },

  /**
   * @description Guarda la config completa. apiKey se preserva si viene
   *              vacío (el form muestra ••••).
   * @param {Object} data - { credentials, types }
   * @returns {Promise<Object>} Config guardada (apiKey mascarado)
   */
  saveConfig(data) {
    return api.put("/whatsapp-notifications-config", data);
  },

  /**
   * @description Envía un mensaje de prueba al teléfono indicado para
   *              validar credenciales 2chat. Si no hay creds propias en
   *              esta config, hereda automáticamente de la config de
   *              monitoreo (mismo número virtual).
   * @param {Object} payload
   * @param {string} payload.toPhone - Destino en E.164
   * @param {string} [payload.text]
   * @returns {Promise<Object>} { success, externalMessageId, inheritedFromMonitoring }
   */
  testMessage(payload) {
    return api.post("/whatsapp-notifications-config/test-message", payload);
  },
};

export default whatsappNotificationsConfigService;
